var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimezoneIcon = function SvgTimezoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9488_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0449 6.4775V10.1892L12.9624 11.9675",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.50781 7.2875V7.2875C4.8294 3.55076 8.93 1.59289 12.6667 2.91448C16.4035 4.23607 18.3613 8.33667 17.0397 12.0734C16.2251 14.3768 14.2945 16.1075 11.9161 16.6667",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 17.5H2.91667V17.5C2.68655 17.5 2.5 17.3135 2.5 17.0833V16.745V16.745C2.50274 15.7824 3.28239 15.0028 4.24499 15H7.005V15C7.9676 15.0027 8.74725 15.7824 8.75 16.745V17.0833C8.75 17.3135 8.56345 17.5 8.33333 17.5V17.5V17.5Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62563 12.9167V12.9167C4.70516 12.9167 3.95898 12.1705 3.95898 11.25C3.95899 10.3295 4.70519 9.58332 5.62567 9.58333C6.54353 9.58334 7.28863 10.3255 7.29231 11.2433V11.2433C7.29599 12.1638 6.55278 12.913 5.63232 12.9167C5.63009 12.9167 5.62786 12.9167 5.62564 12.9167L5.62563 12.9167Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9488_17454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export { SvgTimezoneIcon as ReactComponent };
export default __webpack_public_path__ + "timezone-icon.svg";